import { gql } from '@apollo/client'

export const ARAG_COVERAGE_CHECK_QUERY = gql`
  query aragCoverageCheck($policyNumber: String!, $date: ISO8601Date!, $rsvLegalAreaId: ID!) {
    aragCoverageCheck(policyNumber: $policyNumber, date: $date, rsvLegalAreaId: $rsvLegalAreaId) {
      data {
        valid
        policyDetails
        rawResponse
      }
    }
  }
`
